import React from 'react';
import styles from "../../styles/customer/CustomerList.module.css";

import logo01 from "../../assets/customer/(사)한국인더스트리4.0협회.png";
import logo02 from "../../assets/customer/스튜디오D코딩캠프.png";
import logo03 from "../../assets/customer/여수·순천 10·19사건 진상규명 및 희생자 명예회복 위원회.png";
import logo04 from "../../assets/customer/영남이공대학교.png";
import logo05 from "../../assets/customer/명지전문대학.png";
import logo06 from "../../assets/customer/경민대학교.png";
import logo07 from "../../assets/customer/(주)건설인이인정받는사회.png";
import logo08 from "../../assets/customer/트루컷시큐리티.png";
import logo09 from "../../assets/customer/중소기업기술정보진흥원.png";
import logo10 from "../../assets/customer/엔씨엔스페이스(주).png";
import logo11 from "../../assets/customer/GMS.png";

const customers = [
  { name: "(사)한국인더스트리4.0협회", logo: logo01},
  { name: "스튜디오D코딩캠프", logo: logo02, showLabel: true,},
  { name: "여수·순천 10·19사건 진상규명 및 희생자 명예회복 위원회", logo: logo03},
  { name: "영남이공대학교", logo: logo04},
  { name: "명지전문대학", logo: logo05},
  { name: "경민대학교", logo: logo06},
  { name: "(주)건설인이인정받는사회", logo: logo07},
  { name: "트루컷시큐리티", logo: logo08},
  { name: "중소기업기술정보진흥원", logo: logo09},
  { name: "엔씨엔스페이스(주)", logo: logo10},
  { name: "GMS", logo: logo11},
]

const CustomerList = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <header className={styles.header}>
          <h2 className={styles.heading}>MetaAI와 함께한 고객사</h2>
        </header>

        <div className={styles.grid}>
          {customers.map((c) => (
            <figure key={c.name} className={styles.card}>
              <div className={`${styles.logoWrap} ${c.showLabel ? styles.withLabel : ""}`}>
                <img className={styles.logo} src={c.logo} alt={c.name} loading="lazy" />
                {c.showLabel && <figcaption className={styles.label}>{c.name}</figcaption>}
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CustomerList